<template>
    <v-row>
        <v-col cols="12">
            <div class="">
                <v-btn @click="change = !change" class="change-btn default-btn">Cambiar de Producto</v-btn>
            </div>
        </v-col>
        <v-bottom-sheet v-model="change">
            <v-sheet class="text-center" >
                <div class="d-flex justify-end pt-2 pl-4 pr-4">
                    <v-btn style="text-transform: none;" text color="#999" @click="change = !change" ><v-icon small class="mr-2">mdi-close</v-icon>Cerrar</v-btn>
                </div>
                <div class="py-3 d-none d-md-block">
                    <div class="products-btns-wrapper" v-show="change">
                        <v-btn 
                            v-for="product in products" 
                            :key="product.type" 
                            @click="callChangeActiveProduct(product.type)"
                            class="default-btn"
                            :class="{active: product.type === preScoring.Vivienda.tipo_vivienda}"
                            :disabled="checkProduct(product.type)"
                        >
                            <v-icon v-if="product.icon" class="mr-3">{{product.icon}}</v-icon>
                            {{product.button}}
                            <HelpTooltip class="ml-auto" v-if="product.help" :text="product.help" color="rgba(0,0,0,.5)" />
                        </v-btn>
                    </div>
                </div>
                <div style="min-height:60vh" class="py-15 px-10 d-block d-md-none">
                    <v-select 
                        no-data-text="Sin datos"
                        label="Producto"
                        v-model="preScoring.Vivienda.tipo_vivienda"
                        :items="products"
                        item-text="button"
                        item-value="type"
                        @change="callChangeActiveProduct"
                        outlined
                        color="var(--helloteca-main)"
                    />
                </div>
            </v-sheet>
        </v-bottom-sheet>
    </v-row>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';
    import HelpTooltip from './HelpTooltip';

    export default {
        components:{
            HelpTooltip
        },
        data() {
            return {
                change: false
            }
        },
        methods: {
            ...mapMutations([
                'CHANGE_ACTIVE_PRODUCT'
            ]),
            callChangeActiveProduct(type){
                this.CHANGE_ACTIVE_PRODUCT(type);
                this.change = false;
            },
            checkProduct(type){
                let result = this.showIframe && !['habitual','compra_vivienda_100','2avivienda','mejorar'].includes(type);
                return result;
            }
        },
        computed: {
            ...mapState([
                'preScoring',
                'products',
                'showIframe'
            ])
        },
    }
</script>


<style lang="scss" scoped>
    .default-btn{
        font-family: 'montserrat' !important;
        letter-spacing: initial;
        justify-content: center;
        align-items: center;
        border: 3px solid #E9ECEE;
        border-radius: 10px;
        font-size: 15px;
        background-color: #fff !important;
        padding: 10px 20px !important;
        color: #90A4AE;
        font-weight: 600;
        min-height: 70px;
        vertical-align: super;
        box-shadow: none !important;
        text-transform: none;
        height: auto !important;
        transition: all .2s;
        @media (max-width: 600px) {
            font-size: 12px;
        }
        &:hover{
            background: var(--helloteca-main) !important;
            color:#FFF !important;
            border-color: var(--helloteca-main) !important;
            transition: all .2s;
        }
        &.active{
            border: 2px solid var(--helloteca-main) !important;
            color: #333;
        }
        &.change-btn{
            min-height: auto;
            border-radius: 50px;
            padding: 11px 50px !important;
            height: initial !important;
            border: 2px solid #E9ECEE;
            font-weight: 500;
            color: #333;
            @media (max-width: 600px) {
                 padding: 10px 35px !important;
            }
        }
    }
    .products-btns-wrapper{
        padding: 20px 7% 30px;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 10px;
    }

    @media only screen and (max-width: 1150px) {
        .products-btns-wrapper{
            grid-template-columns: repeat(3, 1fr);
        }
    }

    @media only screen and (max-width: 900px) {
        .products-btns-wrapper{
            grid-template-columns: repeat(2, 1fr);
        }
    }

      @media only screen and (max-width: 600px) {
        .products-btns-wrapper{
            grid-template-columns: repeat(1, 1fr);
        }
    }
</style>